export const wan = {
  disable_dos: "disable_dos",
};

export default wan;
